import WaveSurfer from "wavesurfer.js";

export const AudioWave = {
  mounted() {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // A host page can theme the embed (the embed layout sets --embed-accent);
    // the played part of the waveform takes that accent, the unplayed bars
    // keep the stock grey, and without a theme the played part keeps the
    // stock orange-to-red.
    const controller = document.getElementById("media-controller");
    const playedColour = controller
      ? window.getComputedStyle(controller).getPropertyValue("--embed-accent").trim()
      : "";

    // Define the waveform gradient
    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height * 1.35);
    gradient.addColorStop(0, "#656666"); // Top color
    gradient.addColorStop((canvas.height * 0.7) / canvas.height, "#656666"); // Top color

    // Define the progress gradient
    const progressGradient = ctx.createLinearGradient(
      0,
      0,
      0,
      canvas.height * 1.35
    );
    progressGradient.addColorStop(0, playedColour || "#EE772F"); // Top color
    progressGradient.addColorStop(
      (canvas.height * 0.7) / canvas.height,
      playedColour || "#EB4926"
    ); // Top color

    //from https://wavesurfer.xyz/faq/
    fetch(this.el.dataset.peaksUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((peaks) => {
        const wavesurfer = WaveSurfer.create({
          container: "#waveform",
          waveColor: gradient,
          progressColor: progressGradient,
          barWidth: 2,
          //url: this.el.dataset.audioUrl,
          peaks: peaks.data,
          normalize: false,
          duration: this.el.dataset.duration,
          media: document.querySelector("video"),
        });

        // Hover effect
        {
          const hover = document.querySelector("#hover");
          const waveform = document.querySelector("#waveform");
          waveform.addEventListener(
            "pointermove",
            (e) => (hover.style.width = `${e.offsetX}px`)
          );
        }
      })
      .catch((e) => {
        console.error("error", e);
      });
  },

  destroyed() {},
};
